import Sheet from 'components/utils/Sheet'
import type { ComponentProps } from 'react'
import { memo } from 'react'

type SheetProps = ComponentProps<typeof Sheet>
type InheritedSheetProps = Omit<SheetProps, 'background'>
type SheetBackground = SheetProps['background']

interface Props extends InheritedSheetProps {
  /**
   * @default normal-background
   */
  background?: SheetBackground
}

function Pane({ background = 'normal-background', ...rest }: Props) {
  return (
    <Sheet background={background} {...rest} />
  )
}

export default memo(Pane)
